import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  unit: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing.unit * 6,
  },
});

function Section(props) {
  const { classes, children, extraClasses, id } = props;

  return (
    <React.Fragment>
      <div className={classNames(classes.unit, extraClasses)} id={id}>
        {children}
      </div>
    </React.Fragment>
  );
}

Section.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  extraClasses: PropTypes.string,
};

export default withStyles(styles)(Section);